import React, { useEffect, useRef, useState } from "react";
import tvImage from "../../assets/online/Tv-qsm06do1eaeokuw9gf8fuwwzxp6uxycowjd4gudt2o.png";
import useFreeTrial from "../../hooks/useFreeTrial";

export default function LandingOnlineMetodo() {
  const { handleFreeTrial } = useFreeTrial();
  const [imageLoaded, setImageLoaded] = useState(false);
  const containerRef = useRef(null);
  const imageRef = useRef(null);

  // Usamos IntersectionObserver para detectar la visibilidad
  useEffect(() => {
    const observerOptions = {
      root: null, // Usamos la ventana de visualización
      rootMargin: "0px",
      threshold: 0.3, // Al 10% del componente visible, se activa la animación
    };

    // Función para manejar la visibilidad del componente
    const handleIntersection = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.remove("opacity-0");
          entry.target.classList.add("animate-fade-in");
        } 
      });
    };

    const handleImageIntersection = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.remove("opacity-0");
          entry.target.classList.add("image-animation");
          setTimeout(() => {
            setImageLoaded(true);
          }, 750);
          
        } 
      });
    };

    // Creamos el IntersectionObserver
    const observer = new IntersectionObserver(handleIntersection, observerOptions);
    const imageObserver = new IntersectionObserver(handleImageIntersection, observerOptions);

    // Observamos los componentes
    if (containerRef.current) observer.observe(containerRef.current);
    if (imageRef.current) imageObserver.observe(imageRef.current);

    return () => {
      // Limpiamos el observer cuando el componente se desmonte
      if (containerRef.current) observer.unobserve(containerRef.current);
      if (imageRef.current) imageObserver.unobserve(imageRef.current);
    };
  }, []);

  return (
    <div
      className="online__metodo position-relative opacity-0 bg-purple-dark"
      ref={containerRef}
    >
      <div className="metodo__content d-flex">
        <div className="content__about text-blue">
          <h1 className="about__title">
            Una plataforma diseñada para que puedas ser constante
          </h1>
          <p className="about__desc">
          Entrena desde donde estés con 10 disciplinas, clases de distintas duraciones y coaches expertas que te acompañan según tus tiempos, tu energía y tus objetivos. Porque cuando te mueves con conciencia, no solo cambias físicamente: cambias tu relación contigo misma.
          </p>

          <button type="button" onClick={handleFreeTrial} className="btn bg-blue about__btn my-3">Pruébalo 7 días gratis</button>
        </div>
        
        <div className="content__image">
        <img alt="" src="https://thebodymethod.s3.us-west-1.amazonaws.com/tbmonline-plataforma.jpg" style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "25px" }} ref={imageRef}/>
        </div>
      </div>

      <img alt="" className="metodo__tv-image" src={tvImage}/>
    </div>
  );
}
